<template>
  <div class="p-4">
    <div class="d-flex align-items-center mb-3">
      <i class="fas fa-check-circle mr-2 text-orange"></i>
      <div class="color-gray-7 font-16 font-weight-bold">
        Razón de Aceptación
      </div>
    </div>
    <validation-observer ref="observer" novalidate>
      <validation-provider class="w-100" rules="required" v-slot="{ errors }">
        <div class="color-secondary-6 font-14 font-weight-normal mb-2">
          Comentario:
        </div>
        <custom-text-area
          v-model="model.comment"
          custom-error-msg="El campo Comentario es requerido"
          placeholder="Escriba un comentario"
          :maxlength="3000"
          :error="errors[0]"
        />
      </validation-provider>
    </validation-observer>

    <div class="d-flex align-items-center my-4">
      <i class="fas fa-plus-circle mr-2 text-orange"></i>
      <div class="color-gray-7 font-16 font-weight-bold">
        Seleccione accesorios a transferir con el equipo
      </div>
    </div>
    <div v-for="(item, index) in model.accessories" :key="index">
      <div class="p-3 my-3 bg-white rounded">
        <div class="row d-flex align-items-center px-3">
          <div class="col-md-3 col-12 border-right-2">
            <div class="bold font-16">{{ item.name | empty }}</div>
            <div class="color-secondary-6 font-14">
              {{ item.model | empty }}
            </div>
          </div>
          <div class="col-md ">
            <div class="color-secondary-6 font-14">
              Estatus:
            </div>
            <div class="bold">
              <span class="d-flex align-items-center">
                <div
                  class="status-indicator"
                  :style="{
                    backgroundColor: '#DDB3D7',
                  }"
                >
                  &nbsp;
                </div>
                <span class="text font-weight-bold">
                  Asignado
                </span>
              </span>
            </div>
          </div>
          <div class="col-md  d-flex justify-content-end">
            <action-button
              :variant="
                !item.accepted
                  ? 'outline-success ' + (isMobile ? 'w-100 mt-4' : '')
                  : 'success ' + (isMobile ? 'w-100  mt-4' : '')
              "
              type="button"
              i="fas fa-check"
              data-target="#modal-cambiar"
              @click="approve(item)"
            >
              {{ item.accepted ? 'Aceptado' : 'Aceptar' }}
            </action-button>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end">
      <action-button
        :variant="'outline-danger ' + (isMobile ? 'w-100  mt-4' : 'mr-2')"
        type="button"
        i="fas fa-times-circle"
        @click="cancel"
      >
        Cancelar
      </action-button>
      <action-button
        :variant="'success ' + (isMobile ? 'w-100  mt-4' : '')"
        type="button"
        i="fas fa-save"
        @click="save"
      >
        Guardar
      </action-button>
    </div>
  </div>
</template>
<script>
import mixAlert from '@/mixins/alert.mixin';
import CustomTextArea from '@quisit/custom-text-area';
import ActionButton from 'ActionButton';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';
import service from '@/services/api/inventorycatalog.api';

export default {
  name: 'Acceptance',
  components: {
    CustomTextArea,
    ActionButton,
    ValidationObserver,
    ValidationProvider,
  },
  mixins: [mixAlert],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      model: {
        comment: null,
        accessories: [],
      },
    };
  },
  async mounted() {
    await this.getAccessories();
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
  },
  methods: {
    async getAccessories() {
      const { data } = await service.getAssignedAccessoriesByEquipment(
        this.item.equipmentId
      );
      this.model.accessories = data.map((x) => ({ ...x, accepted: true }));
    },
    approve(item) {
      item.accepted = !item.accepted;
    },
    cancel() {
      this.$emit('close');
    },
    async save() {
      try {
        const valid = await this.$refs.observer.validate();
        if (!valid) return;
        const confirmed = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea aprobar la solicitud?`,
          'Sí',
          'No'
        );

        if (!confirmed) return;
        const { comment, accessories } = this.model;
        const payload = {
          comment,
          accessories: accessories.filter((x) => !x.accepted).map((x) => x.id),
        };
        await service.approveInventoryTransfer(this.item.id, payload);
        this.ShowToast(
          'Éxito',
          'La transferencia se ha aprobada exitosamente.',
          'success'
        );
        this.$emit('refresh');
      } catch (error) {
        this.ShowToast('Error', error?.response?.data.message, 'error');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.status-indicator {
  width: 12px;
  height: 12px;
  float: left;
  border-radius: 50%;
  margin-right: 5px;
}

.border-right-2 {
  border-right-style: solid;
  border-right-width: 2px;
  border-right-color: #dee2e6;
}
</style>
